import React from 'react';
import logo from "../images/logo_react.jpg";
import cart from "../images/Cart.jpg";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
const Header = () => {
    const cartItems = useSelector((state) => state.products.items);

    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/cart')
    }

  return (
    <div className='header'>
        
            <Link to='/' style={{ height:'100%', display:'flex', alignItems:'center' }}><img src={logo} alt="Logo" className='logo'/></Link>
        
       
                <button onClick={handleClick}><img src={cart} alt="Cart" className='cart' /><span>{cartItems.length}</span></button>
           
        
    </div>
  )
}

export default Header

